import { forwardRef } from "react";
import TextInput from "./TextInput";

/**
 * PriceInput — displays a thousands-separated so'm amount while typing
 * (e.g. "65 000 000") but reports the raw numeric value to `onValueChange`,
 * so consumers never have to parse formatted strings themselves.
 *
 * Usage:
 *   <PriceInput value={price} onValueChange={setPrice} label="Narxi" />
 */
const PriceInput = forwardRef(function PriceInput(
  { value, onValueChange, label = "Narxi", ...rest },
  ref
) {
  const formatted = value ? Number(value).toLocaleString("ru-RU") : "";

  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^\d]/g, "");
    onValueChange?.(raw ? Number(raw) : "");
  };

  return (
    <TextInput
      ref={ref}
      inputMode="numeric"
      label={label}
      value={formatted}
      onChange={handleChange}
      rightSlot={<span className="text-body-sm text-brand-muted font-medium">so'm</span>}
      {...rest}
    />
  );
});

export default PriceInput;
